export default (state = [], action) => {
  switch (action.type) {
    case 'APP_COST_DETAILS':
      return action.payload;
    default:
      return state;
  }
};
